import React from 'react';
import { useSelector } from 'react-redux';

import useFilter from '@hooks/useFilter';

import Checkbox from '@features/filter/v2/Checkbox';
import FilterName from '@features/filter/v2/FilterName';

const MaterialQuality = ({ filterPageName }) => {
	const { dependentFilterList } = useSelector((store) => store.dependentFilterListStore);
	const { data, handleSearch } = useFilter(filterPageName, dependentFilterList?.materialQualityList);

	const options = data.map((item) => ({
		...item,
		id: item?.id
	}));

	return (
		<>
			<FilterName type="MATERIAL_QUALITY" />
			<Checkbox data={options} type="MATERIAL_QUALITY" handleSearch={handleSearch} />
		</>
	);
};

export default MaterialQuality;
